import React from "react";
import { useSelector } from "react-redux";
import {
  FaBell,
  FaUsers,
  FaUsersSlash,
  FaMoneyBillAlt,
  FaClipboardList,
  FaUserPlus,
} from "react-icons/fa";
import { IoIosAddCircle } from "react-icons/io";
import { RiHome8Line } from "react-icons/ri";

import { Link } from "react-router-dom";
import preferredLanguage from "../assets/preferredLanguage.json";
import useReminders from "../utils/useReminders";

const MobileBottomMenuScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  // Same hook the reminders page and the desktop sub-menu use, so all three
  // always agree on what is outstanding.
  const { totalCount: reminderCount } = useReminders();
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";
  const bgColor = userInfo?.gymId?.themeColors?.headerBg || "rgb(10, 90, 106)";
  const headerTextColor = userInfo?.gymId?.themeColors?.headerText || "#FFFFFF";
  return (
    <>
      {userInfo && (
        <div
          className={`${userInfo?.themeColor}ThemeFooter bottom-menu`}
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
            padding: "0.4rem 0px 3.5rem 0px",
            zIndex: 1000,
            backgroundColor: bgColor,
            color: headerTextColor,
          }}
        >
          <Link
            to="/allUsers"
            style={{ ...menuButtonStyle, textDecoration: "none" }}
          >
            {" "}
            <FaUsers
              style={{
                width: "0.6rem",
                height: "0.6rem",
                marginBottom: "0.1rem",
              }}
            />
            <span style={{ textAlign: "center", color: "white" }}>
              All
              <br /> Members
            </span>
          </Link>
          <Link
            to="/attendanceList"
            style={{ ...menuButtonStyle, textDecoration: "none" }}
          >
            {" "}
            <FaClipboardList
              style={{
                width: "0.6rem",
                height: "0.6rem",
                marginBottom: "0.1rem",
              }}
            />
            <span style={{ textAlign: "center", color: "white" }}>
              Attendance
              <br /> History
            </span>
          </Link>
          <Link
            to="/userRegistration"
            style={{ ...menuButtonStyle, textDecoration: "none" }}
          >
            {" "}
            <IoIosAddCircle
              style={{
                width: "0.6rem",
                height: "0.6rem",
                marginBottom: "0.1rem",
              }}
            />
            <span style={{ textAlign: "center", color: "white" }}>
              Add
              <br /> Member
            </span>
          </Link>
          {(userInfo.role === "owner" || userInfo.role === "Super Admin") && (
            <Link
              to="/payments"
              style={{ ...menuButtonStyle, textDecoration: "none" }}
            >
              {" "}
              <FaMoneyBillAlt
                style={{
                  width: "0.6rem",
                  height: "0.6rem",
                  marginBottom: "0.1rem",
                }}
              />
              <span style={{ textAlign: "center", color: "white" }}>
                Payments
                <br /> History
              </span>
            </Link>
          )}
          <Link
            to="/pendingPayments"
            style={{ ...menuButtonStyle, textDecoration: "none" }}
          >
            {" "}
            <FaMoneyBillAlt
              style={{
                width: "0.6rem",
                height: "0.6rem",
                marginBottom: "0.1rem",
              }}
            />
            <span style={{ textAlign: "center", color: "white" }}>
              Pending
              <br /> Payments
            </span>
          </Link>
          <Link
            to="/reminders"
            // twinkle-text is the pulse animation already in
            // bootstrap.custom.css, so a pending reminder draws the eye
            // without any new CSS.
            className={reminderCount > 0 ? "twinkle-text" : ""}
            style={{ ...menuButtonStyle, textDecoration: "none" }}
          >
            {" "}
            <FaBell
              style={{
                width: "0.6rem",
                height: "0.6rem",
                marginBottom: "0.1rem",
              }}
            />
            <span style={{ textAlign: "center", color: "white" }}>
              Alerts
              <br /> zone {reminderCount > 0 ? ` (${reminderCount})` : ""}
            </span>
          </Link>{" "}
        </div>
      )}
    </>
  );
};

const menuButtonStyle = {
  border: "none",
  fontSize: "0.7rem",
  color: "inherit",
  cursor: "pointer",
  outline: "none",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export default MobileBottomMenuScreen;
